import React from 'react';
import Radium from 'radium';

import style from './styles';

class ChatFormEnumButton extends React.PureComponent {
  handleClick = () => {
    const { onClick, displayName, value, disabled } = this.props;

    if (disabled) return;

    onClick(value, displayName);
  };

  renderIcon = () => {
    const { icon } = this.props;
    if (!icon) return null;
    return (
      <img src={`//cdn.jsdelivr.net/emojione/assets/png/${icon}.png?v=2.2.6`} alt="team icon" style={style.icon} />
    );
  };

  render() {
    const { displayName, disabled, label } = this.props;
    return (
      <button
        style={style.button}
        onClick={this.handleClick}
        disabled={disabled}
        className="kustomer-app-reply-input-option"
      >
        {this.renderIcon()}
        <span style={style.innerText}>{label || displayName}</span>
      </button>
    );
  }
}

ChatFormEnumButton.propTypes = {
  onClick: React.PropTypes.func,
  displayName: React.PropTypes.string,
  label: React.PropTypes.string,
  icon: React.PropTypes.string,
  value: React.PropTypes.string,
  disabled: React.PropTypes.bool,
};

ChatFormEnumButton.defaultProps = {
  onClick() {},
  disabled: false,
  label: null,
};

export default Radium(ChatFormEnumButton);
